import Button from 'devextreme-react/button';
import DataGrid, { Column, Editing, Format, Item, Toolbar } from 'devextreme-react/data-grid';
import NumberBox from 'devextreme-react/number-box';
import { formatNumber } from 'devextreme/localization';
import { useContext, useState } from 'react';
import { TextBoxWithDelay } from '../../../../components';
import { POCreditMemoContext } from '../context/POCreditMemoContext';
import { CreditMemoCatalogProduct } from '../types/CreditMemoCatalogProduct';
import { POCreditMemoProduct } from '../types/POCreditMemoProduct';
import CreditMemoProductPopup from './CreditMemoProductPopup';

export default function CreditMemoProducts() {

    const { creditMemo, modify } = useContext(POCreditMemoContext);

    let [isProductPopupVisible, setProductPopupVisibility] = useState(false);

    function getBalance(products: POCreditMemoProduct[], shippingChargeAmount?: number) {
        return (shippingChargeAmount ?? 0) - products.reduce((a, b) => a + ((b.price ?? 0) * (b.quantity ?? 0)), 0);
    }

    let products = creditMemo.details.products?.map(x => x) ?? [];

    return (
        <>
            <DataGrid
                dataSource={creditMemo.details.products}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                showColumnLines={true}
                wordWrapEnabled={true}
                keyExpr={'creditMemoProductID'}
                className="grid-with-header"
                onRowUpdated={(e) => {
                    modify({
                        ...creditMemo.details,
                        balance: getBalance(products, creditMemo.details.shippingChargeAmount),
                        products: products
                    });
                }}
            >
                <Editing
                    mode="cell"
                    allowAdding={false}
                    allowDeleting={true}
                    allowUpdating={true}
                />
                <Toolbar>
                    <Item
                        visible={true}
                        location={'after'}
                    >
                        <Button elementAttr={{ 'data-testid': 'btn-add-line' }}
                            text="Add Line"
                            icon="Inscyth-Add"
                            onClick={() => {
                                setProductPopupVisibility(true);
                            }}>
                        </Button>
                    </Item>
                </Toolbar>
                <Column
                    dataField={'sku'}
                    caption={'SKU'}
                    dataType="string"
                    allowEditing={false}
                />
                <Column
                    dataField={'productDescription'}
                    caption={'Product'}
                    dataType="string"
                    allowEditing={false}
                    width={300}
                />
                <Column
                    dataField={'shippedDate'}
                    caption={'Shipped Date'}
                    dataType="date"
                    allowEditing={false}
                />
                <Column
                    dataField={'description'}
                    caption={'Description'}
                    dataType="string"
                    showEditorAlways={true}
                    width={300}
                />
                <Column
                    dataField={'quantity'}
                    caption={'Quantity'}
                    dataType="number"
                    showEditorAlways={true}
                    editorOptions={{ min: 0, showSpinButtons: true, format: "##0.###" }}
                    cssClass="required"
                />
                <Column
                    dataField={'price'}
                    caption={'Price'}
                    dataType="number"
                    showEditorAlways={true}
                    editorOptions={{ min: 0, showSpinButtons: true, format: "$#0.00" }}
                    cssClass="required"
                >
                    <Format type="currency" precision={2} ></Format>
                </Column>
                <Column
                    dataField={'amount'}
                    caption={'Amount'}
                    dataType="number"
                    allowEditing={false}
                    calculateCellValue={(row) => {
                        return -row.quantity * row.price;
                    }}
                >
                    <Format type="currency" precision={2} ></Format>
                </Column>
            </DataGrid>
            <div className='dx-clearfix'></div>
            <table className='summary-table'>
                <tbody>
                    <tr>
                        <td>Shipping Charge Description:</td>
                        <td style={{ paddingLeft: '10px', paddingRight: '30px' }}>
                            <TextBoxWithDelay
                                value={creditMemo.details.shippingChargeDescription}
                                width={300}
                                textChangeDelay={500}
                                onTextChanged={(value) => {
                                    modify({
                                        ...creditMemo.details,
                                        shippingChargeDescription: value
                                    });
                                }}
                            />
                        </td>
                        <td>Shipping Charge Amount:</td>
                        <td>
                            <NumberBox
                                width={100}
                                value={creditMemo.details.shippingChargeAmount}
                                showSpinButtons={true}
                                min={0}
                                format="$#0.00"
                                onValueChanged={(e) => {
                                    modify({
                                        ...creditMemo.details,
                                        shippingChargeAmount: e.value,
                                        balance: getBalance(products, e.value),
                                        products: products
                                    });
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}></td>
                        <td>Balance:</td>
                        <td>
                            {formatNumber(creditMemo.details.balance ?? 0, { type: 'currency', precision: 2 })}
                        </td>
                    </tr>
                </tbody>
            </table>

            <CreditMemoProductPopup
                visible={isProductPopupVisible}
                onPopupHidden={() => setProductPopupVisibility(false)}
                onProductsAdded={(addedProducts: CreditMemoCatalogProduct[]) => {

                    var newProducts = products.concat(addedProducts.map((x, index) => {
                        return {
                            creditMemoProductID: -creditMemo.details.products.length - index - 1,
                            productID: x.productID,
                            quantity: x.quantity,
                            price: 0,
                            sku: x.sku,
                            productDescription: x.description
                        }
                    }));

                    modify({
                        ...creditMemo.details,
                        products: newProducts
                    });
                }}
            />
        </>
    );
}
